import { render, staticRenderFns } from "./BolsaTrabajo.vue?vue&type=template&id=6864e066"
import script from "./BolsaTrabajo.vue?vue&type=script&lang=js"
export * from "./BolsaTrabajo.vue?vue&type=script&lang=js"
import style0 from "./BolsaTrabajo.vue?vue&type=style&index=0&id=6864e066&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports